'use client'

import { styled } from '@mui/material'
import { PageLayout } from '../pageLayout'

export const StyledResources = styled(PageLayout)(({ theme }) => ({
  'ul.custom-list': {
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  'ul.custom-list li': {
    position: 'relative',
    marginBottom: theme.spacing(0),
    paddingLeft: theme.spacing(1.4),
    '&:last-of-type': {
      marginBottom: 0,
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '.6em',
      left: 0,
      width: '8px',
      height: '2px',
      backgroundColor: '#B85967',
    },
  },

  [theme.breakpoints.down('md')]: {
    '.wrapped .accordion-wrapper': {
      paddingLeft: '0 !important',
    },
  },
}))
